module.exports = __webpack_public_path__ + "static/orc-1-31392d7bfe0c66f683b449a793c1ad80.png";